import { useWidth } from '@unified-checkout/kit-components';
import { createContext, ReactNode } from 'react';
import { MOBILE_BREAKPOINT } from '../constants';

interface DeviceContextType {
  isMobile: boolean;
}
export const DeviceContext = createContext<DeviceContextType>({
  isMobile: false,
});
interface DeviceProviderProps {
  children: ReactNode;
}
export const DeviceProvider = ({ children }: DeviceProviderProps) => {
  const isMobile = useWidth(MOBILE_BREAKPOINT);
  return (
    <DeviceContext.Provider value={{ isMobile }}>
      {children}
    </DeviceContext.Provider>
  );
};
